var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list",class:{
    'list-no-top': _vm.toolbarShow === false
  },on:{"&scroll":function($event){return _vm.ScrollEvent($event)}}},[((_vm.f_data instanceof Array && _vm.f_data.length == 0))?_c('div',{staticClass:"list-panel-empty"},[_c('div',{staticClass:"empty-content"},[_c('div',{staticClass:"empty-logo"}),_c('div',{staticClass:"empty-info"},[_vm._v(_vm._s(this.$store.state.noDataMsg))])])]):_c('div',{staticClass:"list-panel"},[_c('div',{staticClass:"left-panel",style:({
        'left': _vm._left,
        'width': _vm.$store.state.local.leftWidth + 'px'
      })},[_c('ZoneLeft',{attrs:{"list":_vm.f_data,"toolbarShow":_vm.toolbarShow}})],1),_c('div',{staticClass:"right-panel",style:({
        'padding-left': _vm.$store.state.local.leftWidth + 'px'
      })},[_c('ZoneRight',{ref:"zoneRight",attrs:{"list":_vm.f_data,"header":_vm.f_header,"toolbarShow":_vm.toolbarShow}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }